import { useEffect } from 'react';
import { useAppSelector } from '../../../hooks';
import {
  selectApiKey,
  selectIsDraft,
  selectIsInteractiveEmailPreview,
  selectOrigin,
} from 'reducers/config';
import {
  selectIsBuilderPreview,
  selectIsSolveConfigPreview,
  selectWorkflowVersion,
} from 'reducers/workflows';

import ApiService from '../../../services/ApiService';

const useInitApiService = () => {
  const apiKey = useAppSelector(selectApiKey);
  const solveOrigin = useAppSelector(selectOrigin);
  const isBuilderPreview = useAppSelector(selectIsBuilderPreview);
  const isSolveConfigPreview = useAppSelector(selectIsSolveConfigPreview);
  const isInteractiveEmailPreview = useAppSelector(
    selectIsInteractiveEmailPreview,
  );
  const workflowVersion = useAppSelector(selectWorkflowVersion);
  const isDraft = useAppSelector(selectIsDraft);

  useEffect(() => {
    ApiService.init({
      apiKey,
      isBuilderPreview,
      isDraft,
      isInteractiveEmailPreview,
      isSolveConfigPreview,
      origin: solveOrigin,
      workflowVersion,
    });
  }, [
    apiKey,
    solveOrigin,
    isBuilderPreview,
    isSolveConfigPreview,
    workflowVersion,
    isDraft,
    isInteractiveEmailPreview,
  ]);
};

export default useInitApiService;
